// extracted by mini-css-extract-plugin
export default {"sharedAccountsItem":"SharedAccountsItem_sharedAccountsItem__N3B0P","actions":"SharedAccountsItem_actions__wvb20","delete":"SharedAccountsItem_delete__NFFPh"};